import React, { PureComponent } from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { message, Button, Radio } from "antd";
import fetchHandler from "@/fetch/fetchHandler";

// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { lockOrderStatus } from "../../../fetch/fetchApi";

const FormItem = Form.Item;

// eslint-disable-next-line arrow-parens
@connect(state => state)
class StubLockOrderStatusClass extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      internationalization: this.props.intl.messages.stubStatusUpdate,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.setState({
          btnLoading: true,
        });
        values.id = this.props.stubId;
        fetchHandler(lockOrderStatus, {
          ...values,
        }).then((res) => {
          if (this.props.setSelectedRowKeysNull) {
            this.props.setSelectedRowKeysNull();
          }
          if (res && res.code === "success") {
            message.success(this.state.internationalization.msg1); // '操作成功');
            if (this.props.onCancel) {
              this.props.onCancel();
            }
            if (this.props.refreshGrid) {
              this.props.refreshGrid();
            }
          }
          this.setState({
            btnLoading: false,
          });
        });
      }
    });
  };

  checkLength(rule, value, callback, item) {
    if ((value && value.length > item) || (value && value.length < 1)) {
      callback(
        `${this.state.internationalization.msg2 - 1}0${
          this.state.internationalization.msg2 - 2
        }${item}${this.state.internationalization.msg2 - 3}`,
      );
    }
    callback();
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const tailFormItemLayout = {
      wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 16, offset: 5 },
      },
    };
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12, offset: 1 },
      },
    };
    return (
      <div>
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label={'是否支持'}>
            {getFieldDecorator("reservable", {
              rules: [
                {
                  required: true,
                  message: '请选择是否支持续约', // "请选择要修改的状态"
                },
              ],
            })(
              <Radio.Group>
                <Radio key="0" value="0">不支持</Radio>
                <Radio key="1" value="1">支持</Radio>
              </Radio.Group>,
              )}
          </FormItem>
          <FormItem {...tailFormItemLayout} style={{ marginTop: 14 }}>
            <Button
              type="primary"
              htmlType="submit"
              disabled={this.state.btnDisabled}
              loading={this.state.btnLoading}>
              {this.state.internationalization.btn1}
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

const StubLockOrderStatus = Form.create()(StubLockOrderStatusClass);

export default injectIntl(StubLockOrderStatus);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubLockOrderStatus.js